export default __webpack_public_path__ + "static/img_1_1-91a180b9bea52eee64d5915b0e31195c.jpg";